import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {ILimitExceededMsg} from "./models/limit-exceeded-msg.model";
import msgs from './limit-exceeded-msgs.json';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {Router} from "@angular/router";
import {PaymentDialogComponent} from "../../../workspace/billing/payment-dialog/payment-dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscription} from "../../../user/user-subscription";
import {TextUtils} from "../../../shared/utils/text-utils";

export type LimitExceededMsgType = 'siteDev' | 'paid-booster-create' | 'trial' | 'trial-booster' | 'paid' | 'paid-booster' | 'enterprise' | 'enterprise-booster' | 'business-ecommerce';

@Component({
    selector: 'db-limit-exceeded',
    templateUrl: './limit-exceeded.component.html',
    styleUrls: ['./limit-exceeded.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LimitExceededComponent implements OnInit {

  @Input() limitExceededType: LimitExceededMsgType;
  @Input() userSubscription: UserSubscription;
  @Input() fromCreationCard: boolean;
  public msg: ILimitExceededMsg;

  constructor(
    private _activeModal: DbActiveModal,
    private _router: Router,
    private _dialogService: DialogService,
  ) { }

  ngOnInit() {
    this._activeModal.resize(null, 700);
    this._activeModal.hideCloseBtn(true);
    this._getLimitExceededMsg();
  }

  public closeDialog(): void {
    this._activeModal.close();
  }

  private _getLimitExceededMsg(): void {
    const rawMsg = msgs[this.limitExceededType];
    // Resolve textMap keys
    this.msg = {
      title: TextUtils.getText(rawMsg.title),
      desc: TextUtils.getText(rawMsg.desc),
      btnLabel: TextUtils.getText(rawMsg.btnLabel),
      btnColor: rawMsg.btnColor
    };
  }

  public handleAction(): void {
    this._activeModal.close();
  }
}
